












































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Moment from 'moment'
import { Apis, Factories, Services } from '@finx/web-repository'
import StoreRelatorios from '@/store/Relatorios'
import Relatorios from '@finx/web-repository/src/apis/Legacy/services/Relatorios'

@Component

export default class ViewRelatorio extends Vue {
  loadings: any = {
    getRelatorio: false,
  }

  recebimentoFilter: String = 'fonte-pagadora'
  refreshRelatorio: Boolean = false

  relatorio: any = {}

  relatorioPeriod: any = {
    start: '',
    end: '',
  }

  get getRelatorioTypes() {
    const abas: any[] = []

    if (this.getAbasExibir.exibirFontePagadoraProducao) {
      abas.push({
        id: 0,
        name: 'Fonte pagadora',
        subname: 'Produção',
        slug: 'fonte-pagadora',
      })
    }
    if (this.getAbasExibir.exibirOperadoraProducao) {
      abas.push({
        id: 1,
        name: 'Operadora',
        subname: 'Produção',
        slug: 'operadora',
      })
    }
    if (this.getAbasExibir.exibirRecebimentoConciliacao) {
      abas.push({
        id: 2,
        name: 'Recebimento',
        subname: 'Conciliação',
        slug: 'recebimento',
        detail: 'fonte-pagadora',
      })
    }
    return abas
  }

  showRelatoriosFiltros: Boolean = false

  usuario: any = {}

  get dataSelecionada(): String { return StoreRelatorios.getters.DATA_SELECIONADA }
  set dataSelecionada(newValue) { StoreRelatorios.commit('DATA_SELECIONADA', newValue) }

  @Watch('dataSelecionada')
  watchDataSelecionada(newValue, oldValue) {
    if (oldValue !== '') {
      this.setRelatorioPeriod()
      this.getRelatorio()
    }
  }

  get detail(): String { return this.$route.params.detail }
  set detail(newValue) {
    //
  }

  get detailValue(): String { return this.$route.params.detailValue }
  set detailValue(newValue) {
    //
  }

  get typeReport(): String { return this.$route.params.typeReport }
  set typeReport(newValue) {
    this.resetForm()
  }

  get listaMeses() {
    let dataCorrente = new Date()
    let dataFinal = this.truncateTime(
      new Date(dataCorrente.getFullYear(), dataCorrente.getMonth(), 1),
    )
    const dataInicial = Moment(dataFinal).add(-12, 'M').toDate()
    dataFinal = Moment(dataFinal).add(6, 'M').toDate()

    const listaMeses = []
    dataCorrente = dataInicial

    while (dataCorrente <= dataFinal) {
      // @ts-ignore
      listaMeses.push(`${Moment(dataCorrente).locale('pt-br').format('MMM').toUpperCase()}/${Moment(dataCorrente).format('YY')}`)
      dataCorrente = this.truncateTime(
        new Date(Moment(dataCorrente).add(1, 'M').toDate().getFullYear(), Moment(dataCorrente).add(1, 'M').toDate().getMonth(), 1),
      )
    }

    return listaMeses
  }

  set listaMeses(newValue) {
    //
  }

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  set prestador(newValue) {
    StoreRelatorios.commit('PRESTADOR', newValue)
  }

  get profissionalExecutante(): any {
    return StoreRelatorios.getters.PROFISSIONAL_EXECUTANTE
  }

  set profissionalExecutante(newValue) {
    StoreRelatorios.commit('PROFISSIONAL_EXECUTANTE', newValue)
  }

  get getAbasExibir(): any {
    return StoreRelatorios.getters.ABAS_EXIBIR
  }

  set getAbasExibir(value) {
    StoreRelatorios.commit('ABAS_EXIBIR', value)
  }

  async mounted() {
    await this.init()
    this.setInitialDate()
    this.recebimentoFilter = this.$route.params.detail || 'fonte-pagadora'
    if (this.relatorio) this.relatorio = {}
    if (this.prestador) this.prestador = {}
    if (this.profissionalExecutante) this.profissionalExecutante = {}

    this.setRelatorioPeriod()
    this.getRelatorio()
  }

  async loadAbasExibir() {
    const request = await Apis.Legacy.Relatorios.abasExibir()
    const success = Factories.Apis.success(request)

    if (success) {
      this.getAbasExibir = request.data
    }
  }

  async getRelatorio() {
    this.loadings.getRelatorio = true
    this.relatorio = {}

    const requestParams = {
      initialDate: this.relatorioPeriod.start,
      finalDate: this.relatorioPeriod.end,
      relatorioType: this.typeReport,
      prestadorId: this.prestador.id,
      profissionalExecutanteId: this.profissionalExecutante.id,
    }

    const isRelatorioRecebimento = this.typeReport === 'recebimento'

    if (isRelatorioRecebimento) {
      this.refreshRelatorio = !this.refreshRelatorio
    } else {
      const request = await Apis.Legacy.Relatorios.getRelatorio(requestParams)
      const success = Factories.Apis.success(request)

      if (success) {
        this.relatorio = request.data.data
      }
    }

    this.loadings.getRelatorio = false
  }

  async getUsuario() {
    this.usuario = this.$user.profile
  }

  resetForm() {
    this.prestador = {}
    this.profissionalExecutante = {}
  }

  setInitialDate() {
    let dataCorrente = new Date()
    dataCorrente = this.truncateTime(
      new Date(dataCorrente.getFullYear(), dataCorrente.getMonth(), 1),
    )
    this.dataSelecionada = `${Moment(dataCorrente).locale('pt-br').format('MMM').toUpperCase()}/${Moment(dataCorrente).format('YY')}`
  }

  setRelatorioPeriod() {
    const mes = this.dataSelecionada.substring(0, this.dataSelecionada.indexOf('/'))
    const ano = this.dataSelecionada.substring(this.dataSelecionada.indexOf('/') + 1)

    const data = Moment(`${ano}-${mes}-01`, 'YY-MMM-DD', 'pt-br').toDate()

    const dataInicial = new Date(data.getFullYear(), data.getMonth(), 1)
    dataInicial.setHours(0)
    dataInicial.setMinutes(0)
    dataInicial.setSeconds(0)
    dataInicial.setMilliseconds(0)

    const dataFinal = new Date(data.getFullYear(), data.getMonth() + 1, 0)
    dataFinal.setHours(23)
    dataFinal.setMinutes(59)
    dataFinal.setSeconds(59)
    dataFinal.setMilliseconds(999)

    const hasPrestadorFontePagadora = Object.keys(StoreRelatorios.getters.PRESTADOR).length > 0

    this.relatorioPeriod.start = Factories.Epoch.dateToEpoch(dataInicial)
    this.relatorioPeriod.end = Factories.Epoch.dateToEpoch(dataFinal)
  }

  selectReportType(slug, detail) {
    if (slug !== 'recebimento') {
      this.$ga.event('consulta-producao', slug, this.usuario.email)
    }

    this.typeReport = slug
    // @ts-ignore
    this.$router.push({
      params: {
        typeReport: slug,
        detail: detail || null,
        // @ts-ignore
        detailValue: null,
      },
    })
  }

  truncateTime(data) {
    data.setHours(12)
    data.setMinutes(0)
    data.setSeconds(0)
    data.setMilliseconds(0)

    return data
  }

  async init() {
    await this.loadAbasExibir()
  }
}
